:root ._dsp-flex{display:flex;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-row{flex-direction:row;}
:root ._items-center{align-items:center;}
:root ._height-60px{height:60px;}
:root ._width-10037{width:100%;}
:root ._bg-backgroundB3327275{background-color:var(--backgroundBlock);}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._pos-absolute{position:absolute;}
:root ._t--350px{top:-350px;}
:root ._l-0px{left:0px;}
:root ._r-0px{right:0px;}
:root ._height-350px{height:350px;}
:root ._shrink-1{flex-shrink:1;}
:root ._grow-1{flex-grow:1;}